module.exports = __webpack_public_path__ + "img/signal-fair.4d17ae69.svg";